"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.checkUploadRequest = exports.sendUpload = void 0;
var axios_1 = __importDefault(require("axios"));
var helpers_1 = require("../helpers");
var helpers_2 = require("../helpers");
var UPLOAD_HEADERS = {
    'Content-Type': 'multipart/form-data'
};
var DEFAULT_HEADERS = {
    'Content-Type': 'application/json'
};
function sendUpload(data, progressCallback) {
    return axios_1["default"].post(helpers_1.baseUrl + "/upload/", data, {
        headers: UPLOAD_HEADERS,
        onUploadProgress: function (event) { return progressCallback('uploading', '', Math.round((event.loaded * 100) / event.total)); }
    });
}
exports.sendUpload = sendUpload;
function checkUploadRequest(taskId, userUUID, userSessionUUID) {
    var endpointUrl = helpers_1.baseUrl + "/upload-check/";
    var headers = DEFAULT_HEADERS;
    var data = {
        doc_id: taskId,
        user_flag: true,
        user_session_uuid: userSessionUUID,
        user_uuid: userUUID,
        mobile: helpers_2.checkMobile()
    };
    return axios_1["default"].post(endpointUrl, JSON.stringify(data), {
        headers: headers
    });
}
exports.checkUploadRequest = checkUploadRequest;
